import SortBy from './sort-by';

export default SortBy;
